import { AxiosRequestConfig } from "axios";
import FreespinRequestBuilder from "slotworks/integration/revolver/builders/requests/freespin-request-builder";
import PickRequestBuilder from "slotworks/integration/revolver/builders/requests/pick-request-builder";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import { default as RevolverModel, default as revolverModel } from "slotworks/integration/revolver/model/revolver-model";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import SlotDefinition from "slotworks/model/slot-definition";
import { RequestBuilder } from "slotworks/server/builders/request-builder";
import WrapperMediator from "slotworks/integration/revolver/wrapper/wrapper-mediator";
import { log } from "util";
import settingsModel from "slotworks/model/settings/settings-model";

class SpinRequestBuilder implements RequestBuilder {

    public force: string;
    public customStops: string[][];

    public filter(data: any): boolean {
        return data instanceof SpinRequestPayload;
    }

    public build(gameplay: Gameplay, data: any) {
        const spinRequestPayload = data as SpinRequestPayload;

        const totalBet = spinRequestPayload.stakePerLine * Math.max(spinRequestPayload.lines.length, 1) * spinRequestPayload.coinSize;
        WrapperMediator.roundStart(totalBet, gameplay.balance);

        // Revolver take the index of the value in the array (but not 0 indexed) instead of the value
        const coinLevel = SlotDefinition.coinSizes.indexOf(spinRequestPayload.coinSize) + 1;

        const action: any = {
            bet: {bet_level: spinRequestPayload.stakePerLine / revolverModel.creditBaseMultiplier, coin_level: coinLevel, lines: spinRequestPayload.lines.length}
        };

        const freespins = CampaignsModel.freespins;
        if (CampaignsModel.isFreespinsActive()) {
            action.availableCampaignDetails = {
                type: freespins.type,
                awardId: freespins.awardId
            };
        }

        if (this.force) {
            action.force = this.force;
            this.force = null;
            FreespinRequestBuilder.force = null;
            PickRequestBuilder.force = null;
        }
        if (this.customStops) {
            action.customForce = this.customStops;
            this.customStops = null;
        }

        const requestPayLoad: any = {
            cmd: "RESULTS",
            additionalData: {},
            session: RevolverModel.session,
            action
        };

        // For some troubleshooting we need to add more metadata in the requests
        try {
            if (RevolverModel.getGameCode()) {
                requestPayLoad.additionalData.gameCode = RevolverModel.getGameCode();
            }
            if (RevolverModel.getOperator()) {
                requestPayLoad.additionalData.getOperator = RevolverModel.getOperator();
            }
            if (RevolverModel.getOperatorId()) {
                requestPayLoad.additionalData.getOperatorId = RevolverModel.getOperatorId();
            }
            if (RevolverModel.getBranding()) {
                requestPayLoad.additionalData.getBranding = RevolverModel.getBranding();
            }
            if (window && window.location) {
                if (window.location.hasOwnProperty("pathname")) {
                    requestPayLoad.additionalData.windowPath = window.location.pathname;
                }
            }
            if (RevolverModel.sendBetConfigInResult) {
                requestPayLoad.additionalData.betConfig = RevolverModel.betConfig;
            }
        } catch (e) {
            log(e);
        }

        const requestConfig = {
            method: "post",
            url: RevolverModel.getBaseURL(),
            withCredentials: true,
            data: JSON.stringify(requestPayLoad)
        } as AxiosRequestConfig;

        if (RevolverModel.jwt_token) {
            requestConfig.headers = {
                "X-RGS-SESSION-TOKEN": RevolverModel.jwt_token
            };
        }

        if(action.bet.bet_level == null || action.bet.bet_level == 0) {
            const logObject = {
                spl: spinRequestPayload.stakePerLine, 
                cbm: revolverModel.creditBaseMultiplier,
                auth: settingsModel.authData,
                bs: settingsModel.betState
            }
            throw new Error(JSON.stringify(logObject));
        }


        return requestConfig;

    }
}

export default new SpinRequestBuilder();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/builders/requests/spin-request-builder.ts